/**
 * Module Resolution Utilities
 *
 * Safe utilities for handling module resolution issues without
 * directly manipulating webpack internals.
 */

// Detect if this is a hard refresh (F5)
export const isHardRefresh = (): boolean => {
  try {
    // Modern approach
    if ('navigation' in window && (window as any).navigation?.entries) {
      return (window as any).navigation.entries().length === 1
    }

    // Fallback to deprecated API
    if (window.performance?.navigation) {
      return window.performance.navigation.type === 1
    }

    // Final fallback
    return document.referrer === ''
  } catch {
    return false
  }
}

// Clear session storage related to webpack errors on successful load
export const clearErrorTracking = () => {
  try {
    sessionStorage.removeItem('webpack_reload_attempts')
  } catch {
    // Ignore if sessionStorage is not available
  }
}

// Initialize on app load
if (typeof window !== 'undefined') {
  // Clear error tracking on successful app initialization
  clearErrorTracking()

  // Log hard refresh detection for debugging
  if (process.env.NODE_ENV === 'development' && isHardRefresh()) {
    console.log('Hard refresh detected (F5)')
  }
}